import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type { CareerLevel } from "~/modules/humanResources/api/careerLevel/careerLevelTypes.ts";

export const getAllCareerLevels = (): AxiosApiResponsePromise<CareerLevel[]> => axiosApi.get("career-levels");
